var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlideButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#0000C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8836 24.8928L20.7221 17.4798C21.2938 16.8683 22.211 16.8645 22.7906 17.3421C23.3702 17.8198 23.439 18.7544 22.9354 19.3041L18.2185 24.4148H35.5344C36.3436 24.4148 36.9998 25.0372 36.9998 25.8048C36.9998 26.5724 36.3436 27.1948 35.5344 27.1948H18.2185L22.9354 32.3055C23.439 32.8552 23.3572 33.7759 22.7906 34.2675C22.1971 34.7823 21.2257 34.6795 20.7221 34.1298L13.8836 26.7167C13.4035 26.1092 13.4294 25.4248 13.8836 24.8928Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideButton);
export default __webpack_public_path__ + "static/media/slide_button.4dca5a6c4392f028076def022462232f.svg";
export { ForwardRef as ReactComponent };